import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';

class RequestToJoinOrgSuccessMessageModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orgJoinResponseMessage: ""
		};
	}

	componentDidMount() {

	}

	handleOk = (event) => {
		this.props.closeRequestToJoinOrgSuccessMessageModal();
	}

	render () {

		return (
			<Modal onHide={this.props.handleOrgJoinResponseMessageModal} show={this.props.showRequestToJoinOrgSuccessMessageModal} aria-labelledby="ModalHeader">
            	<Modal.Header closeButton>
              		<Modal.Title id='ModalHeader'>FirstNet Developer Program</Modal.Title>
            	</Modal.Header>
            	<Modal.Body>
					Your request to join this organization/company has been submitted.
					<br/>
					<b>Keep an eye on your inbox.</b>
					<br/>
					the administrator for your organization/company must now review your request. Upon
					approval, you will receive a confirmation email. If the organization/company has AT&T API
					Platform access, then so do you!
            	</Modal.Body>
            	<Modal.Footer>
              		<button className='btn btn-primary' onClick={this.handleOk} name="Ok">
                		Ok
              		</button>          		
            	</Modal.Footer>
          </Modal>
		)
	}
}

export default RequestToJoinOrgSuccessMessageModal;



// WEBPACK FOOTER //
// ./src/manageOrg/RequestToJoinOrgSuccessMessageModal.js